import React from 'react';
import { Spin } from 'antd';
import { LoaderCircle } from 'lucide-react';

/**
 * Lite-style full-area loading spinner.
 * Usage: <PageLoader /> or <PageLoader loading={isLoading}>{children}</PageLoader>
 *
 * Props:
 *   loading  {boolean} - whether to show the spinner (default true when used standalone)
 *   text     {string}  - optional label below the spinner
 *   children - when provided, wraps content and shows spinner overlay while loading=true
 */
const PageLoader = ({ loading = true, text = 'Loading...', children, minHeight = 320 }) => {
    if (children !== undefined) {
        if (!loading) return children;
        return (
            <div style={{ position: 'relative', minHeight }}>
                {/* Dim the content underneath */}
                <div style={{ opacity: 0.35, pointerEvents: 'none', userSelect: 'none' }}>{children}</div>
                <LoaderOverlay text={text} />
            </div>
        );
    }

    if (!loading) return null;
    return (
        <div style={{ minHeight, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <LoaderOverlay text={text} inline />
        </div>
    );
};

const LoaderOverlay = ({ text, inline }) => (
    <div
        style={
            inline
                ? { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 14 }
                : {
                    position: 'absolute', inset: 0,
                    display: 'flex', flexDirection: 'column',
                    alignItems: 'center', justifyContent: 'center', gap: 14,
                    zIndex: 10,
                }
        }
    >
        {/* Spinning ring */}
        <div className="cdx-page-loader-ring" />
        {text && (
            <span style={{ fontSize: 13, color: '#64748b', fontWeight: 500 }}>{text}</span>
        )}
    </div>
);

export default PageLoader;
